// extracted by mini-css-extract-plugin
export default {"section-surface-wrapper":"U6Jt7","sectionSurfaceWrapper":"U6Jt7"};